import { useTranslation } from "react-i18next";
import SectionHeader from "../common/SectionHeader";
import { getLandingProjectsSection } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";
import LandingSection from "./LandingSection";
import ScrollReveal, { revealItemProps } from "./ScrollReveal";
import SectionLoader from "../common/SectionLoader";
import "./LandingSections.css";

function LandingProjects({ acf, galleryItems = [], loading = false }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <LandingSection className="landing-projects">
        <SectionLoader size="lg" label={t("Loading section")} />
      </LandingSection>
    );
  }

  const { title, description } = getLandingProjectsSection(acf);

  if (!title && !description && galleryItems.length === 0) return null;

  return (
    <LandingSection className="landing-projects">
      {title || description ? (
        <ScrollReveal className="landing-section__intro">
          <SectionHeader
            title={title || undefined}
            subtitle={description || undefined}
            showAccent
            centered
            titleId="landing-projects-title"
            containerClass=""
          />
        </ScrollReveal>
      ) : null}
      {galleryItems.length > 0 ? (
        <div className={SECTION_CONTAINER}>
          <ScrollReveal
            className="landing-projects__grid landing-section__body"
            stagger
            aria-labelledby={title ? "landing-projects-title" : undefined}
          >
            {galleryItems.map((item, index) => (
              <figure
                key={item.id}
                {...revealItemProps(
                  index,
                  "caf-media-frame aspect-square overflow-hidden",
                )}
              >
                <img
                  src={item.url}
                  alt={item.alt || item.title || ""}
                  title={item.title || undefined}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover"
                  width={item.width || undefined}
                  height={item.height || undefined}
                />
              </figure>
            ))}
          </ScrollReveal>
        </div>
      ) : null}
    </LandingSection>
  );
}

export default LandingProjects;
